import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkuFeedbackComponent } from './sku-feedback.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SkuFeedbackComponent
  ],
  exports: [
    SkuFeedbackComponent
  ],
})
export class SkuCapsuleFeatureSkuFeedbackModule {}
